import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from './components/ErrorBoundary.js';
import { ToastProvider } from './components/Toast.js';
import OfflineBanner from './components/OfflineBanner.js';
import App from './App.js';
import { HelmetProvider } from 'react-helmet-async';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <App />
          <OfflineBanner />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
      </HelmetProvider>
  </React.StrictMode>
);
